import { render, staticRenderFns } from "./palm2.vue?vue&type=template&id=68616a9c&scoped=true&"
import script from "./palm2.vue?vue&type=script&lang=js&"
export * from "./palm2.vue?vue&type=script&lang=js&"
import style0 from "./palm2.vue?vue&type=style&index=0&id=68616a9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68616a9c",
  null
  
)

export default component.exports